import { Injectable } from '@angular/core';
import { FileSystemFileEntry } from 'ngx-file-drop';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppStorage } from './appStorage.service';
import { ENDPOINTS } from '../constants/app-values';

@Injectable({
  providedIn: 'root'
})
export class AWSService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  eliminarArchivoTmp(anno, mes, proceso, archivo) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token
    });

    const body = {
      key: 'temp/' + anno + mes + proceso.sigla + '/' + archivo.nombreArchivo
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/awsFile/coordinador/eliminarTmp/`, body, {
        headers: headers
      })
      .toPromise();
  }

  eliminarArchivosTmp(anno, mes, proceso) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token
    });

    const body = {
      prefix: 'temp/' + anno + mes + proceso + '/'
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/awsFile/coordinador/eliminarTmps/`, body, {
        headers: headers
      })
      .toPromise();
  }

  subirArchivo(archivo, anno, mes, proceso) {
    const promise = new Promise((resolve, reject) => {
      const fileEntry = archivo.fileEntry as FileSystemFileEntry;

      fileEntry.file((file: File) => {
        const headers = new HttpHeaders({
          Authorization: this.appStorage.token
        });

        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'name',
          'temp/' + anno + mes + proceso + '/' + archivo.nombreASubir
        );
        /* while ceating bucket we alread grant the public access
          for read operation as if now we are only performing that.*/

        return this.httpClient
          .post(`${ENDPOINTS.HOST}/awsFile/coordinador/subir/`, formData, {
            headers: headers
          })
          .toPromise()
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    });

    return promise;
  }

  moverArchivoTempAProcesos(archivo, anno, mes, proceso) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token
    });

    const body = {
      from: 'temp/' + anno + mes + proceso + '/' + archivo.nombreArchivo,
      to: 'procesos/' + anno + mes + proceso + '/' + archivo.nombreArchivo
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/awsFile/coordinador/publicar/`, body, {
        headers: headers
      })
      .toPromise();
  }

  publicarArchivoEmpresa(archivo, nombreArchivo, anno, mes, proceso) {
    const promise = new Promise((resolve, reject) => {
      const fileEntry = archivo.fileEntry as FileSystemFileEntry;

      fileEntry.file((file: File) => {
        const headers = new HttpHeaders({
          Authorization: this.appStorage.token
        });

        const formData = new FormData();
        formData.append('file', file);
        formData.append(
          'name',
          'procesos/' + anno + mes + proceso + '/' + nombreArchivo
        );
        /* while ceating bucket we alread grant the public access
          for read operation as if now we are only performing that.*/

        return this.httpClient
          .post(`${ENDPOINTS.HOST}/awsFile/coordinador/subir/`, formData, {
            headers: headers
          })
          .toPromise()
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    });

    return promise;
  }
}
